<template>
  <div>


    <!-- Modal MESSAGE -->  
    <modalMessage ref="msgModal"/>


      <updateCollection v-if="documentId" v-bind:documentId="documentId"  @close="closeModalCollection()"></updateCollection>
      <updateBulkCollection v-if="bulkUpdate" v-bind:items="selectedItems" @close="closeModalCollection()"></updateBulkCollection>
       
        
      <div class="table-wrapper-scroll-y my-custom-scrollbar table-responsive-sm">
      <table class="table table-bordered table-hover table-sm  table-striped mb-0" id="table">
        
      <thead>
        <tr>
            <th class="text-center" :colspan="14 + (selectedItems.length == 0 ? 0 : 1) " style="" >
               
              
               <span style="color:white; font-size:24px" > {{name}}</span>

            </th> 
        </tr>
        <tr class="stick">

          <th>#</th>
      
          <th></th>
          <th>
            COLLEZIONE
          </th>          
          <th v-if="selectedItems.length>0"></th>
          <th>BRAND/STAGIONE ANAGRAFICA PRODOTTO</th>
           <th>TIPO</th>
          <th>NUMERO</th>
          <th>DATA</th>
          <th>SEDE</th>
          <th>CREATO IL</th>
          <th class="text-right">TOTALE Q.TA'</th>
          <th class="text-right">TOTALE IMPONIBILE</th>
          <th class="text-right">TOTALE IVA</th>
          <th class="text-right">TOTALE €</th>
          
          <th class="text-center"> STAMPA ETICHETTE</th>
          
              
        </tr>
      </thead>
      <tbody>
      <tr @click.ctrl=setItem(item) data-toggle="tooltip" title="doppio click modifica documento" @dblclick="openDocument(item)" class="pointer" v-for="(item,index) in filteredDocuments" :key="index">
        <td>{{index+1}}</td>
        <td>
          <i @click="updateCollection(item,)" data-toggle="tooltip" title="modifica collezione"  class="fa fa-edit" aria-hidden="true">
          
        </i>
        <td>
          {{ item.collection_description }}
        </td>
        </td>
        
        
        <td v-if="selectedItems.length>0">
          <i v-if="item.selected" :style="{color:'red'}" class="fas fa-thumbtack" aria-hidden="true"></i>
        </td>
        <td>{{item.data}}</td>
         <td>{{item.description}}</td>
        <td class="text-left">{{item.number}}</td>
        <td class="text-left">{{item.date}}</td>
        <td class="text-left">{{item.store}}</td>
        <td class="text-left">{{item.create_at}}</td>
        <td class="text-right">{{item.totalQty}}</td>
        <td class="text-right">{{fmt1(item.totalTaxableAmount)}}</td>

        <td class="text-right">{{fmt1(item.totalTaxAmount)}}</td>
        <td class="text-right">{{fmt1(item.totalAmount)}}</td>
          <td class="text-center" v-if="company.printer_type=='EPL'" >
          <i @click="printModal(item,'EPL')" data-toggle="tooltip" title="stampa etichette"  class="fa fa-print" aria-hidden="true">
          <span v-if="btn1 && spinner"  class="spinner-border spinner-border-sm ml-2"  role="status" aria-hidden="true"></span>
          </i></td>
        <td class="text-center" v-if="company.printer_type=='ZPL'" ><i class="fa fa-print"
          @click="printModal(item,'ZPL')" data-toggle="tooltip" title="stampa etichette ZEBRA"   aria-hidden="true">
          <span v-if="btn2 && spinner"  class="spinner-border spinner-border-sm ml-2"  role="status" aria-hidden="true"></span>
          </i></td>
      </tr>
      </tbody>
      <tfoot>
        <tr>                  
        </tr>
      </tfoot>  
    </table>
  </div>

  
        
  <div class="form-group mt-5">
  <label for="cerca"><strong>Filtra</strong></label>
  <input id="cerca" class="form-control" type="text" name="query" v-model="filterKey">
  </div>
  

  <button v-if="selectedItems.length>0" @click="bulkUpdate=true" class="btn btn-primary mt-1 mb-1">      
      <i class="fas fa-edit mr-2" aria-hidden="true"></i>
      MODIFICA COLLEZIONE DOCUMENTI SELEZIONATI
     
    </button>



  
  

  <div v-if="movementId>0">
    
    <print-epl-modal :key="refreshEPL" v-bind:data='data'></print-epl-modal>
    <printZebraModal :key="refreshZPL" v-bind:data='data'></printZebraModal>  

  </div>
  

  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import api                       from '@/api'

import printZebraModal           from '@/components/common/PrintZebraModal.vue';
import printEplModal             from '@/components/common/PrintJSPMModal.vue';

import updateCollection          from '@/components/backOffice/UpdateMovementCollection.vue'
import updateBulkCollection      from '@/components/backOffice/UpdateBulkCollection.vue'
import fmt                       from '@/components/mixins/fmt.js'
import modalMessage              from '@/components/modalDialog/ModalMessage.vue'   


  export default {

     components: {printZebraModal,printEplModal,updateCollection,updateBulkCollection,modalMessage},
     props : ['supplierId','name','range'],
     mixins:[fmt],
    data () {
      return {
        
        bulkUpdate    : false,
        selectedItems : [],

        items         : [],
        filterKey     : '',
        spinner       : false,
        movementId    : 0,
        documentId    : 0,
        data          : [],
        refreshEPL    : 0,
        refreshZPL    : 100,
      
        btn1          : false,
        btn2          : false 
                
      }
    },
    watch :
    {

    },
    
  
    computed: {
      ...mapGetters(['company']),
      
       filteredDocuments : function () 
      {
        var filterKey = this.filterKey && this.filterKey.toLowerCase()
        var items = this.items
        if (filterKey) {
        items = items.filter(function (row) {
          return Object.keys(row).some(function (key) {
            return String(row[key]).toLowerCase().indexOf(filterKey) > -1
          })
        })
      }
        return items
     },
     
  
      
    },
    mounted()
    {
      this.getDocuments()
    },
    created () 
    {       
      
    },
    methods: 
    {
    
    setItem(item)  
    {
      this.selectedItems = []
      item.selected = !item.selected
      
      this.filteredDocuments.forEach(item=>{


        if(item.selected)
        {
          this.selectedItems.push({'stockMovementId':item.movementId})
        }
      })
      
    },
    closeModalCollection()
    {
      this.selectedItems = []
      this.bulkUpdate = false
      this.documentId = 0
      this.getDocuments()
    } ,  
    updateCollection(item)  
    {
      this.documentId = item.documentId
    }, 
     
      getData() 
      {
      

        const data  = {'movementId' : this.movementId}
        const sp    = {'sp':'spStockMovementBarcodes'}
        const json  = Object.assign(data, sp)
        return new  Promise( async (resolve, reject)  =>  {
        
        await api.post(json).then(res => {
          
          if(res.status==200)
            {
               resolve(res.data.recordsets[0])   
            }
           else if(res.status == 500)
           {
                
                
                console.log(res.data)                    
           } 
           else
            { 
                
                console.log('Network Error.')                  
                 
            } 
          

          }).catch(err => {
              
              console.log(err.message)    

              
          }).finally(() => {
          //this.spinner = false
        });          
        
        })

      }, 
    



      async printModal(item,lang)
      {
        this.spinner = true  
        this.btn1  = lang == 'EPL' ? true : false
        this.btn2  = lang == 'ZPL' ? true : false
        this.movementId = item.movementId
        this.data = await this.getData()
        this.spinner = false
        
        if(lang=='EPL')
        {
          this.refreshEPL++
          this.$nextTick(() => {
            $('#printEPLModal').modal({keyboard: false,backdrop:'static','show':true});
            })
        }
        else
        {
          this.refreshZPL++
          this.$nextTick(() => {
           $('#printZebraModal').modal({keyboard: false,backdrop:'static','show':true});
            
        })  
        }
        
      },

      
      
      openDocument(item)
      {
        
        this.$emit('update',item)
      },


      async getDocuments()
      {
        
        
       const sp       = 'spSupplierDocumentsNew'
       const payload  = {'supplierId' : this.supplierId,'companyId':this.company.Id,'range':this.range,sp}

        this.$refs.msgModal.show()        
        this.$refs.msgModal.setSpinner(true)  
               
        try{
        
          const res = await api.post(payload)
          if (res.status !== 200) 
          {
            throw new Error(res.data ||  res)
          }
            this.$refs.msgModal.close() 
            this.items = res.data.recordsets[0] 
            
              this.items.forEach(item => {
                this.$set(item, 'selected', false)
              }); 





        }catch(err){

            this.$refs.msgModal.setSpinner(false)
            this.$refs.msgModal.show(err) 
        }
        
       

        


      },
      




      
      

    }
  }
</script>

<style scoped>
  
.pointer:hover
{
  background-color : blue;
  color            : white;
  cursor           : pointer;
}



p,h4 {
  font-family : 'Roboto Condensed';
  font-size   : 20px;
   }
.header {
  font-family : 'Roboto Condensed';
}




.table,
.table th, 
.table td
{
  border-color: #3b28a7 !important;
}

 .fa-print:hover{

    color : red;
}
 .fa-print{

     color       : brown;

 }
 .text-right_{
  
  font-weight  : bold;
  font-size    : 18px;
  
 }
 .text-left_{
  
  font-weight  : bold;
  font-size    : 18px;
  
 }


.table {
  border-collapse: separate;
}


.my-custom-scrollbar {
  height: 500px;
  overflow-y: auto;
}

.table-wrapper-scroll-y {
  display: block;
}

/* tutti gli header */
.table thead th {
  position    : sticky;
  background  : #5c8fb1;
  color       : white;
  z-index     : 10;
}

/* prima riga */
.table thead tr:nth-child(1) th {
  top: 0;
  z-index: 20;
}

/* seconda riga */
.table thead tr:nth-child(2) th {
  top         : 50px;   /* altezza reale della prima riga */
  z-index     : 19;
  color       : rgb(16, 16, 15) !important;
  background  : #a9cbe2;
}
</style>
